const SLUG_BY_LABEL = {
  Open: "open",
  Closed: "closed",
  Hold: "hold",
  "Open & Hold": "open_hold",
  Any: "any",
  Unknown: "unknown",
};

export function getTicketStatusSlug(status) {
  if (!status) {
    return "unknown";
  }

  return SLUG_BY_LABEL[status] ?? "unknown";
}

const ICON_BY_SLUG = {
  closed: "x",
  open: "check",
  hold: "chevron",
  open_hold: "chevron",
  any: "chevron",
};

export function getTicketStatusIconType(status) {
  return ICON_BY_SLUG[getTicketStatusSlug(status)] ?? "none";
}
